import compose from "recompose/compose";
import Select from './select';
import config from './config';

export default compose(config, Select);